{
  "tenant": {
    "title": "Horario de la organización",
    "description": "Define la jornada estándar de la organización. Es la base para los cálculos de capacidad y carga de trabajo.",
    "hoursPerDay": "Horas por día",
    "workingDays": "Días laborables por semana",
    "isDefaultBadge": "Predeterminado",
    "save": "Guardar horario",
    "saving": "Guardando...",
    "loadError": "No fue posible cargar el horario de la organización."
  },
  "segments": {
    "add": "Agregar segmento",
    "remove": "Eliminar segmento"
  },
  "overrides": {
    "title": "Horarios personalizados",
    "description": "Miembros con una jornada distinta a la de la organización.",
    "empty": "Sin horarios personalizados",
    "emptyDescription": "Todos los miembros usan el horario de la organización.",
    "hoursPerDay": "{{count}} h/día",
    "memberLabel": "Miembro {{userId}}",
    "updatedAt": "Actualizado {{time}}",
    "searchPlaceholder": "Buscar por miembro...",
    "edit": "Editar horario",
    "loadError": "No fue posible cargar los horarios personalizados."
  },
  "member": {
    "title": "Horario de trabajo",
    "description": "Define las horas por día de {{name}}.",
    "hoursPerDay": "Horas por día",
    "inheritsDefault": "Hereda el horario de la organización ({{hours}} h/día).",
    "save": "Guardar",
    "saving": "Guardando...",
    "delete": "Eliminar horario",
    "deleteConfirm": "Eliminar horario personalizado",
    "deleteConfirmDesc": "El miembro volverá a usar el horario de la organización. Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "loadError": "No fue posible cargar el horario del miembro.",
    "savedToast": "Horario actualizado",
    "savedToastDesc": "El horario de {{name}} ha sido actualizado.",
    "deletedToast": "Horario eliminado",
    "deletedToastDesc": "{{name}} volverá a usar el horario de la organización."
  },
  "errors": {
    "daysRequired": "Los días laborables son obligatorios",
    "daysInt": "Los días laborables deben ser un número entero",
    "daysRange": "Los días laborables deben estar entre 1 y 7",
    "segmentsEmpty": "Agrega al menos un segmento de horario",
    "segmentTimeRequired": "Selecciona una hora de inicio y fin para este segmento",
    "segmentEndBeforeStart": "La hora de fin debe ser posterior a la hora de inicio",
    "segmentsOverlap": "Los segmentos deben estar en orden y no pueden solaparse"
  },
  "apiErrors": {
    "invalidHours": "El valor de horas por día no es válido",
    "invalidDays": "El valor de días laborables no es válido",
    "memberNotFound": "El miembro no fue encontrado",
    "tenantSaveDefault": "No fue posible guardar el horario de la organización",
    "memberSaveDefault": "No fue posible guardar el horario del miembro",
    "memberDeleteDefault": "No fue posible eliminar el horario del miembro"
  }
}
